import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IGeoLocationsEditParams,
  IGeoLocationsParams,
  IGeoPlacesQueryParams,
  IGeoPlacesResponse,
} from "~/entity/Geo/model/shema";
import { cleanObject } from "~/shared/lib/cleanObject/cleanObject";

const geoPlaceServiceMap = {
  geoLocation: "/geo/location",
  geoPlaces: "/geo/places",
};

export class GeoPlaceService {
  static GET = {
    byId: (id: string | number): NetworkResponse<IGeoLocationsParams> =>
      requestREST.get(`${geoPlaceServiceMap.geoLocation}/${id}`),

    getGeoPlaces: (
      params: IGeoPlacesQueryParams = {},
    ): NetworkResponse<IGeoPlacesResponse> =>
      requestREST.get(geoPlaceServiceMap.geoPlaces, {
        params: cleanObject(params),
      }),
  };

  static POST = {
    add: (data: IGeoLocationsParams): NetworkResponse<unknown> =>
      requestREST.post(geoPlaceServiceMap.geoLocation, data),
  };

  static PUT = {
    set: (data: IGeoLocationsEditParams): NetworkResponse<unknown> =>
      requestREST.put(geoPlaceServiceMap.geoLocation, data),
  };

  static DELETE = {
    delete: (id: number): NetworkResponse<unknown> =>
      requestREST.delete(geoPlaceServiceMap.geoLocation, { data: { id } }),
  };
}
